import { render } from "./Attachements.vue?vue&type=template&id=54c05f57"
import script from "./Attachements.vue?vue&type=script&lang=js"
export * from "./Attachements.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__